import {
  AtomicIcon,
  BankIcon,
  BeakerIcon,
  BookBookmarkIcon,
  BookFlaskIcon,
  BookIcon,
  BookOpenIcon,
  BooksAppleIcon,
  BrandenburgGateIcon,
  BusIcon,
  CalculatorIcon,
  Calendar31Icon,
  ChipIcon,
  ClockIcon,
  CodingIcon,
  CoinsIcon,
  CompassRulerIcon,
  DnaIcon,
  DocumentSuitcaseIcon,
  EiffelTowerIcon,
  GlobeIcon,
  GlobeLeafIcon,
  HammerScrewdriverIcon,
  HandHeartIcon,
  KeyboardIcon,
  LightBulbIcon,
  LineChartIcon,
  MathSymbolsIcon,
  MicroscopeIcon,
  Monitor3dIcon,
  MountainsIcon,
  MusicNoteIcon,
  OilRigIcon,
  OlivesIcon,
  PaletteIcon,
  PencilBrushIcon,
  PencilRulerIcon,
  PersonHeartIcon,
  PianoIcon,
  PieChartIcon,
  PisaIcon,
  RoomClockIcon,
  RunningShoeIcon,
  SewingMachineIcon,
  ShamrockIcon,
  StadiumIcon,
  StarIcon,
  TeaCupIcon,
  TelescopeIcon,
  TheaterMasksIcon,
  TranslateIcon,
  TreesIcon,
  WeldingMaskIcon,
  WrenchRulerIcon,
} from '@tyro/icons';

export const iconList = {
  palette: {
    icon: PaletteIcon,
    search: ['art', 'paint'],
  },
  'pencil brush': {
    icon: PencilBrushIcon,
    search: ['art', 'paint'],
  },
  'pencil ruler': {
    icon: PencilRulerIcon,
    search: [],
  },
  calculator: {
    icon: CalculatorIcon,
    search: ['maths', 'business'],
  },
  'math symbols': {
    icon: MathSymbolsIcon,
    search: ['maths', 'business'],
  },
  book: {
    icon: BookIcon,
    search: [],
  },
  'book bookmark': {
    icon: BookBookmarkIcon,
    search: ['english'],
  },
  'open book': {
    icon: BookOpenIcon,
    search: [],
  },
  'books apple': {
    icon: BooksAppleIcon,
    search: ['books', 'apple'],
  },
  'book flask': {
    icon: BookFlaskIcon,
    search: ['science'],
  },
  piano: {
    icon: PianoIcon,
    search: ['music'],
  },
  'music note': {
    icon: MusicNoteIcon,
    search: ['music'],
  },
  microscope: {
    icon: MicroscopeIcon,
    search: ['science', 'biology'],
  },
  atomic: {
    icon: AtomicIcon,
    search: ['science', 'chemistry'],
  },
  'oil rig': {
    icon: OilRigIcon,
    search: ['geography'],
  },
  beaker: {
    icon: BeakerIcon,
    search: ['science', 'chemistry'],
  },
  telescope: {
    icon: TelescopeIcon,
    search: ['science', 'physics'],
  },
  'eiffel tower': {
    icon: EiffelTowerIcon,
    search: ['french'],
  },
  'brandenburg gate': {
    icon: BrandenburgGateIcon,
    search: ['german'],
  },
  olives: {
    icon: OlivesIcon,
    search: ['spanish'],
  },
  'sewing machine': {
    icon: SewingMachineIcon,
    search: ['Home economics'],
  },
  shamrock: {
    icon: ShamrockIcon,
    search: ['irish'],
  },
  globe: {
    icon: GlobeIcon,
    search: ['geography', 'world', 'map', 'history'],
  },
  'globe leaf': {
    icon: GlobeLeafIcon,
    search: ['world', 'map', 'eco', 'climate'],
  },
  mountains: {
    icon: MountainsIcon,
    search: ['geography'],
  },
  translate: {
    icon: TranslateIcon,
    search: ['language'],
  },
  bank: {
    icon: BankIcon,
    search: ['finance', 'building'],
  },
  stadium: {
    icon: StadiumIcon,
    search: ['sports', 'classic'],
  },
  pisa: {
    icon: PisaIcon,
    search: ['italian', 'italy'],
  },
  trees: {
    icon: TreesIcon,
    search: ['nature', 'agricultural', 'science'],
  },
  dna: {
    icon: DnaIcon,
    search: ['science', 'biology'],
  },
  'compass ruler': {
    icon: CompassRulerIcon,
    search: ['maths', 'drawing'],
  },
  'wrench ruler': {
    icon: WrenchRulerIcon,
    search: ['construction'],
  },
  'hammer screwdriver': {
    icon: HammerScrewdriverIcon,
    search: ['construction'],
  },
  'welding mask': {
    icon: WeldingMaskIcon,
    search: ['metal', 'work', 'engineering'],
  },
  'monitor 3d': {
    icon: Monitor3dIcon,
    search: ['computer', 'graphics'],
  },
  coding: {
    icon: CodingIcon,
    search: ['technology', 'programming'],
  },
  chip: {
    icon: ChipIcon,
    search: ['technology'],
  },
  coins: {
    icon: CoinsIcon,
    search: ['finance', 'accounting'],
  },
  'document suitcase': {
    icon: DocumentSuitcaseIcon,
    search: ['business', 'finance', 'accounting'],
  },
  'line chart': {
    icon: LineChartIcon,
    search: [],
  },
  'pie chart': {
    icon: PieChartIcon,
    search: [],
  },
  keyboard: {
    icon: KeyboardIcon,
    search: ['typewriting'],
  },
  'person heart': {
    icon: PersonHeartIcon,
    search: ['person', 'heart', 'caring'],
  },
  'running shoe': {
    icon: RunningShoeIcon,
    search: ['pe', 'physical'],
  },
  'hand heart': {
    icon: HandHeartIcon,
    search: ['religion'],
  },
  'theater masks': {
    icon: TheaterMasksIcon,
    search: ['play', 'drama'],
  },
  lightbulb: {
    icon: LightBulbIcon,
    search: ['philosophy'],
  },
  clock: {
    icon: ClockIcon,
    search: ['attendance'],
  },
  star: {
    icon: StarIcon,
    search: ['behaviour'],
  },
  'tea cup': {
    icon: TeaCupIcon,
    search: ['drink', 'coffee', 'break'],
  },
  'room clock': {
    icon: RoomClockIcon,
    search: ['time'],
  },
  calendar: {
    icon: Calendar31Icon,
    search: ['time', 'event'],
  },
  bus: {
    icon: BusIcon,
    search: ['coach', 'transport', 'trip', 'activity'],
  },
} as const;

export type IconPickerType = keyof typeof iconList;

export const iconPickerMap = new Map(
  Object.entries(iconList).map(([key, { icon }]) => [key, icon]),
) as Map<IconPickerType, typeof BookIcon>;
